import { useMsal } from '@azure/msal-react'
import { Box, Tabs } from '@mantine/core'
import AdsRequiringContentCheck from '../components/admin/AdsRequiringContentCheck'
import AllLocationsPricingTab from '../components/admin/AllLocationsPricingTab'
import CommunityGemzTab from '../components/admin/CommunityGemz/CommunityGemzTab'
import CouponCodes from '../components/admin/CouponCodes'
import InactiveDevices from '../components/admin/InactiveDevices'
import LocationReports from '../components/admin/LocationReports'
import DesignRequestsPage from './dashboard/DesignRequestsPage'

function AdminPage() {
  const { instance } = useMsal()

  return (
    <Box p={24} h='100%'>
      <Tabs defaultValue='contentCheck'>
        <Tabs.List>
          <Tabs.Tab value='contentCheck' title='Ads requiring content check'>
            Content Check
          </Tabs.Tab>
          <Tabs.Tab value='pendingDesign' title='Items pending design'>
            Pending Design
          </Tabs.Tab>
          <Tabs.Tab value='inactiveDevices' title='Inactive Devices'>
            Inactive Devices
          </Tabs.Tab>
          <Tabs.Tab value='reports' title='Location Reports'>
            Reports
          </Tabs.Tab>
          <Tabs.Tab value='couponCodes' title='Coupon Codes'>
            Coupon Codes
          </Tabs.Tab>
          <Tabs.Tab value='communityGemz'>Community Gemz</Tabs.Tab>
          <Tabs.Tab value='allLocationsPricing' title='All Locations Pricing'>
            All Locations Pricing
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value='contentCheck'>
          <AdsRequiringContentCheck />
        </Tabs.Panel>
        <Tabs.Panel value='pendingDesign'>
          <DesignRequestsPage isAdmin />
        </Tabs.Panel>
        <Tabs.Panel value='inactiveDevices'>
          <InactiveDevices />
        </Tabs.Panel>
        <Tabs.Panel value='reports'>
          <LocationReports instance={instance} />
        </Tabs.Panel>
        <Tabs.Panel value='couponCodes'>
          <CouponCodes />
        </Tabs.Panel>
        <Tabs.Panel value='communityGemz'>
          <CommunityGemzTab />
        </Tabs.Panel>
        <Tabs.Panel value='allLocationsPricing'>
          <AllLocationsPricingTab />
        </Tabs.Panel>
      </Tabs>
    </Box>
  )
}

export default AdminPage
